<ridango-page-content-wrapper>
    <ridango-block-full-width>
        <span class="step" role="text" attr.aria-label="{{ 'BLOCK_STEP_ARIA_LABEL' | translate }} {{1}}">{{1}}</span>
        <h2 class="block-full-width__title">{{ 'CHOOSE_TRAVEL_CARD' | translate }}</h2>
        <p class="block-full-width-message__content__description">{{ 'CHOOSE_TRAVEL_CARD_DESC' | translate }}</p>

        <div class="width-280 margin-auto card-details-area">
            <ridango-ui-basic-loading-spinner [ariaLabel]="'LOADER_LOADING_ARIA_LABEL' | translate"
                *ngIf="!(relatedCardsLoaded$ | async)"></ridango-ui-basic-loading-spinner>

            <ridango-dropdown-filter-wcag *ngIf="(relatedCardsLoaded$ | async)" class="card-dropdown" aria-live="polite"
                [attr.aria-busy]="(relatedCardsLoaded$ | async)" [items]="walttiCards"
                (onItemSelected)="setRelatedCard($event)" [placeholder]="'TRAVEL_CARD'">
            </ridango-dropdown-filter-wcag>
        </div>
    </ridango-block-full-width>

    <ridango-block-full-width [isEmpty]="step < 2">
        <span class="step" role="text" attr.aria-label="{{ 'BLOCK_STEP_ARIA_LABEL' | translate }} {{2}}">{{2}}</span>
        <h2 class="block-full-width__title">{{ 'ENTER_VALIDITY_PERIOD' | translate }}</h2>

        <ng-container *ngIf="step >= 2">
            <p class="block-full-width__description" *ngIf="step >= 2">{{ 'ENTER_VALIDITY_PERIOD_DESC' | translate }}
            </p>
            <div class="width-280 margin-auto">
                <ridango-datepicker [date]="startDate" [useMaterialIcon]="true" (dateUpdated)="setValidityDate($event)">
                </ridango-datepicker>
            </div>
        </ng-container>
    </ridango-block-full-width>

    <ridango-block-full-width [isEmpty]="step < 3">
        <span class="step" role="text" attr.aria-label="{{ 'BLOCK_STEP_ARIA_LABEL' | translate }} {{3}}">{{3}}</span>
        <h2 class="block-full-width__title">{{ 'ENTER_PURCHASE_REFERENCE' | translate }}</h2>
        <ng-container *ngIf="step >= 3">
            <p class="block-full-width__description" *ngIf="step >= 3">{{ 'ENTER_PURCHASE_REFERENCE_DESC' | translate }}
            </p>
            <div class="width-280 margin-auto">
                <ridango-form-field class="form-margin-10">
                    <input ridangoInput [formControl]="seutulippuForm.controls.referenceNumber"
                        (blur)="setPurchaseReference()">
                    <ridango-label>{{'PURCHASE_REFERENCE_LABEL' | translate}}</ridango-label>

                    <ridango-error *ngIf="seutulippuForm.controls.referenceNumber.hasError('required')">
                        {{'FIELD_VALIDATION_REQUIRED' | translate}}
                    </ridango-error>

                    <ridango-error
                        *ngIf="seutulippuForm.controls.referenceNumber.touched && seutulippuForm.controls.referenceNumber.hasError('pattern')">
                        {{'FIELD_VALIDATION_REFERENCE_NUMBER_INVALID_FORMAT' | translate}}
                    </ridango-error>
                </ridango-form-field>
            </div>
        </ng-container>
    </ridango-block-full-width>
</ridango-page-content-wrapper>

<div class="block--bg-wrapper ticket-summary">
    <h2 class="title-bg-wrapper">{{ 'PAGE_TITLE_YOUR_TICKET' | translate }}</h2>
    <p class="align-center" *ngIf="step <= 3">{{ 'SEUTULIPPU_DEFINE_YOUR_TICKET' | translate }}</p>

    <ng-container *ngIf="step > 3">
        <ridango-page-content-wrapper>
            <div class="margin-bottom-30">
                <ridango-ui-ticket-wrapper [isPending]="true">
                    <ridango-ui-ticket-block [position]="'left'" [noPadding]="true">
                        <ridango-ui-ticket-block-item [label]="'PRODUCT' | translate" [isSecondaryValue]="true">
                            {{ 'SEUTULIPPU' | translate }}</ridango-ui-ticket-block-item>
                        <ridango-ui-ticket-block-item [label]="'VALIDITY' | translate" [isSecondaryValue]="true">
                            {{ seutulippuForm.controls.validity.value | date: 'yyyy-MM-dd' }}
                        </ridango-ui-ticket-block-item>
                    </ridango-ui-ticket-block>

                    <ridango-ui-ticket-block [position]="'right'" [noPadding]="true">
                        <ridango-ui-ticket-block-item [label]="'TRAVEL_CARD' | translate" [isFullWidth]="true"
                            [isSecondaryValue]="true">{{ selectedCard.card_nr }}</ridango-ui-ticket-block-item>
                    </ridango-ui-ticket-block>
                </ridango-ui-ticket-wrapper>
            </div>
        </ridango-page-content-wrapper>

        <div class="block block--wrap">
            <div class="summary-module-area">
                <div class="summary-module-area__btn">
                    <button class="btn btn--maximal btn--primary" (click)="submitRequest()"
                        [disabled]="(seutulippuLoading$ | async)">
                        {{ 'REGISTER_SEUTULIPPU_TICKET' | translate }}
                    </button>

                    <ridango-ui-basic-loading-spinner [ariaLabel]="'LOADER_LOADING_ARIA_LABEL' | translate"
                        *ngIf="(seutulippuLoading$ | async)"></ridango-ui-basic-loading-spinner>
                </div>
            </div>
        </div>
    </ng-container>
</div>
